<template>
  <div class="sbRateList">
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width"
          :min-width="120"
          :sortable="item.sortable"
          :field="item.field"
          :formatter="item.formatter"
          :params="item.params"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>
<script>
  import API from '@/api/capitalCenter/settle';
  import tableMixins from '@/common/mixins/table.js';
  export default {
    name: 'sbRateList',
    mixins: [tableMixins],
    computed: {
      // 搜索栏表格展示字段
      searchColumns() {
        return [
          {
            // 框架协议编号
            prop: 'orderNo',
            name: this.$t('sbRateConfig.column.orderNo'),
            type: 'input',
          },
          {
            // 利率类型
            prop: 'interestType',
            name: this.$t('sbRateConfig.column.interestType'),
            type: 'dict',
            dictType: 'sbInterestType',
          },
          {
            // 利率计价单位
            prop: 'interestUnit',
            name: this.$t('sbRateConfig.column.interestUnit'),
            type: 'dict',
            dictType: 'sbInterestUnit',
          },
        ];
      },
    },
    data() {
      return {
        query: {
          orderNo: null,
          interestType: null,
        },
        columnListDefault: [
          { type: 'checkbox', width: '50', fixed: 'left' }, // 复选框
          { field: 'orderNo', title: 'sbRateConfig.column.orderNo' }, // 框架协议编号
          {
            field: 'interestType',
            title: 'sbRateConfig.column.interestType',
            dictType: 'sbInterestType',
          }, // 利率类型
          {
            field: 'interestUnit',
            title: 'sbRateConfig.column.interestUnit',
            dictType: 'sbInterestUnit',
          }, // 利率计价单位
          {
            field: 'occupationPeriod',
            title: 'sbRateConfig.column.occupationPeriod',
            dictType: 'sbOccupationPeriod',
          }, // 利率周期
          { field: 'settleNo', title: 'sbRateConfig.column.settleNo' }, // 结算批次编号
        ],
      };
    },
    mounted() {
      this.getData();
      this.getButtonList();
    },
    methods: {
      async getData() {
        // 获取列表数据
        this.load = true;
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const params = { ...this.query, pageNum, pageSize };
        let res = await this.$axios.post(API.QUERY_SETTLRINTERESTRATECONFIG_PAGE, params);
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        }
      },
      chooseClick(type) {
        if (type == 'add') {
          // 新增
          this.toPath('sbRateAdd', {});
        } else if (type == 'edit') {
          // 修改
          if (this.multipleSelection.length != 1) {
            return this.tips('xTable.selectOne', 'error');
          }
          this.toPath('sbRateEdit', { id: this.multipleSelection[0].id });
        } else if (type == 'del') {
          // 删除
          this.handleDel();
        }
      },
      handleDel() {
        // 删除
        if (this.multipleSelection.length == 0) {
          return this.tips('message.noData', 'error');
        }
        let ids = this.multipleSelection.map((i) => {
          return i.id;
        });
        this.$confirmAction(this.$t('confirm.delete'))
          .then(() => {
            this.$axios.post(API.DELETE_SETTLRINTERESTRATECONFIG, ids).then((res) => {
              if (0 == res.data.code) {
                this.$message({ showClose: true, message: res.data.msg, type: 'success' });
                this.resetBtnClick();
              } else {
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.tips('confirm.deleteCancelled', 'info');
          });
      },
      dblclickEvent(value) {
        // 列表双击
        this.toPath('sbRateDetail', { id: value.row.id });
      },
      tips(info, type) {
        // 提示
        this.$message({ showClose: true, message: this.$t(info), type: type });
      },
      toPath(name, query) {
        // 跳转路径
        let path = {
          path: `/settle/${name}`,
          name: name,
          meta: {
            keepAlive: true,
          },
          query: query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>
